import { render, staticRenderFns } from "./AdditionalServiceSectionView.vue?vue&type=template&id=a53402d4&scoped=true&"
import script from "./AdditionalServiceSectionView.vue?vue&type=script&lang=js&"
export * from "./AdditionalServiceSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53402d4",
  null
  
)

export default component.exports